export enum ApplianceDetailsFormField {
  Manufacturer = 'manufacturer',
  PurchaseMonth = 'purchaseMonth',
  PurchasePrice = 'purchasePrice',
  PurchaseYear = 'purchaseYear',
  WasBoughtWithin12Months = 'wasBoughtWithin12Months',
}
